// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import './assets/styles/index.css'
import 'medium-editor/dist/css/medium-editor.css'
import 'medium-editor/dist/css/themes/default.css'
import 'medium-editor/dist/js/medium-editor.js'

import "swiper/css/swiper.min.css";
import 'swiper/js/swiper.min'

// 导入共用组件
import global from './components/global'
Vue.prototype.global = global


import '@/icons'
Vue.config.productionTip = false

Vue.prototype.axios = axios;
function setFavicon() {
  const domain = window.location.hostname
  let faviconUrl = '/static/favicon.ico' // 默认图标
  let pageTitle = 'AI智搜'
  // 根据不同的域名设置不同的图标路径
  if (domain.includes('geo.kbyun.com')) {
    faviconUrl = '/static/favicon1.ico'
    pageTitle = '快帮AI智搜'
  } else {
    faviconUrl = '/static/favicon.ico'
    pageTitle = 'AI智搜'
  }
  // 您可以添加更多 else if 分支

  // 获取并修改 <link> 元素的 href
  const linkElement = document.querySelector('link[id="dynamic-favicon"]') || document.querySelector('link[rel="icon"]')
  if (linkElement) {
    linkElement.href = faviconUrl
  }
  document.title = pageTitle
}

// 在创建应用实例之前或之后调用
setFavicon()
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  axios,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js